import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject } from '../../interfaces'
import { ISafetyReportStatus } from '../../interfaces'

type Params = {
  portalKey: string
  trackingKey: string
}

const request = (params: Params): IGetRequestObject => {
  const { portalKey, trackingKey } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyReport/${portalKey}/Status/${trackingKey}`,
  }
}

const useSafetyReportStatus = buildGetQuery<Params, undefined, ISafetyReportStatus | undefined>({
  getRequest: request,
  getQueryKey: params => ['safety-report-status', params.portalKey, params.trackingKey],
})

export default useSafetyReportStatus
